/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  return {
    variables: {
      filter: [
        {
          environment: process.env.REACT_APP_ENV,
        },
      ],
    },
  }
}
